import React from "react";

const AlignToRight = ({ handleAlignToRight }) => {
  const handleOnClick = () => {
    handleAlignToRight();
  };

  return (
    <a
      className="tool__option tool__option--align tool__option--align-right"
      onClick={handleOnClick}
    >
      <div className="icon-align__icon">
        <div className="icon-align__svg">
          <svg
            className="icon-align icon-align__center"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 37 32"
            width="37"
            height="32"
          >
            <path
              className="icon-align__path icon-align__path--wide"
              d="M1 15.5h21M1 20.5h21M1 10.5h21"
            />
            <path className="icon-align__path" d="M25.4.5v31" />
          </svg>
        </div>
        <div className="icon-align__text">Right</div>
      </div>
    </a>
  );
};

export default AlignToRight;
